// extracted by mini-css-extract-plugin
module.exports = {"avatar":"tnUYT5EtTHlsAh475r3nY","userName":"GyVrPeOXouTfzcHziTjVl","menu":"T6hN2zBTj-tjFwKkoXOS-"};